import { Box, SearchField, matchText } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import { DefaultShift } from 'modules/shift_management/lib/types'
import { useGetPlannedBreaks } from 'modules/time_planning/hooks/plannedBreaks/useGetPlannedBreaks'

import QuickActionsItem from './QuickActionsItem'

interface Props {
  savedShifts: DefaultShift[]
  onClose: () => void
  contractVersions: ContractVersions
}

const Content = ({ savedShifts, onClose, contractVersions }: Props) => {
  const { daysByRow } = useSelectionState()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const filteredVisibleDefaultShifts = useUnsafeMemo(
    () => savedShifts.filter((ds) => matchText(debouncedSearch, ds.title)),
    [debouncedSearch, savedShifts]
  )

  const defaultShiftIds = savedShifts.map((ds) => ds.id)

  const { plannedBreaksCollection } = useGetPlannedBreaks({
    variables: { defaultShiftIds },
    skip: !defaultShiftIds.length,
  })

  return (
    <Box gap="s16">
      <Box>
        <SearchField
          placeholder={i18n.t('shift_management.add_shift.search_by_title')}
          onSearch={onSearch}
          search={search}
        />
      </Box>
      <Box gap="s8" maxHeight="s240" overflowY="auto">
        {filteredVisibleDefaultShifts.map((defaultShift: DefaultShift) => (
          <PopoverMenu.Close key={defaultShift.id}>
            <Box onClick={onClose}>
              <QuickActionsItem
                defaultShift={defaultShift}
                plannedBreaks={plannedBreaksCollection.active.filterByDefaultShift(defaultShift.id)}
                daysByRow={daysByRow}
                withSearch={search}
                contractVersions={contractVersions}
              />
            </Box>
          </PopoverMenu.Close>
        ))}
      </Box>
    </Box>
  )
}

export default observer(Content)
